// Keep the public View site (config/site) on YogaKai copy. Signed-in clients
// can write that row; we skip when already at this revision so operator edits
// after a Yogakai seed are preserved until SEED_REVISION bumps.
import { onAuthChanged } from '../data/authPlane';
import { db } from '../firebaseConfig';
import { getSupabase, isPg } from '../data/supabaseClient';
import {
  YOGA_SITE_SEED_REVISION,
  YOGA_SITE_SEED_TYPE,
  yogaSiteDoc,
} from './yogaSiteContent';

let started = false;

function needsSeed(existing) {
  if (!existing || !existing.sections) return true;
  if (existing.seedType !== YOGA_SITE_SEED_TYPE) return true;
  return Number(existing.seedRevision || 0) < YOGA_SITE_SEED_REVISION;
}

async function readSite() {
  if (isPg()) {
    const supabase = getSupabase();
    if (!supabase) return null;
    const { data, error } = await supabase.from('config').select('data').eq('id', 'site').maybeSingle();
    if (error) throw new Error(error.message);
    return data?.data || null;
  }
  if (!db) return null;
  const snap = await db.doc('config/site').get();
  return snap.exists ? snap.data() : null;
}

async function writeSite(doc) {
  if (isPg()) {
    const supabase = getSupabase();
    if (!supabase) throw new Error('Supabase client unavailable');
    const { error } = await supabase.from('config').upsert({ id: 'site', data: doc });
    if (error) throw new Error(error.message);
    return;
  }
  if (!db) throw new Error('Firestore unavailable');
  await db.doc('config/site').set(doc);
}

async function ensureOnce() {
  const existing = await readSite();
  if (!needsSeed(existing)) return;
  await writeSite(yogaSiteDoc());
  // eslint-disable-next-line no-console
  console.log(`[yoga] public site seeded (revision ${YOGA_SITE_SEED_REVISION})`);
}

/** Call once from the layer entry — runs after a member signs in. */
export function ensureYogaSite() {
  if (typeof window === 'undefined' || started) return () => {};
  started = true;
  return onAuthChanged((user) => {
    if (!user || user.isAnonymous) return;
    ensureOnce().catch((err) => {
      // eslint-disable-next-line no-console
      console.warn(`[yoga] site seed skipped: ${err.message}`);
    });
  });
}
